export enum ActionStatus {
  COMPLETED = 'COMPLETED',
  IN_PROGRESS = 'IN_PROGRESS',
  NO_ITERATIONS = 'NO_ITERATIONS',
  NOT_STARTED = 'NOT_STARTED',
  FAILED = 'FAILED',
  CANCELLED = 'CANCELLED',
  INTERNAL_ERROR = 'INTERNAL_ERROR',
}
